  
  
  
  
  
  
  document.addEventListener('DOMContentLoaded', function () {
    const faqWrappers = document.querySelectorAll('.faq-question-wrapper');

    faqWrappers.forEach(wrapper => {
      wrapper.addEventListener('click', function () {
        const faqItem = this.closest('.faq-item');
        const answer = faqItem.querySelector('.faq-answer');
        const icon = faqItem.querySelector('.faq-icon svg');

        // Close all other items
        document.querySelectorAll('.faq-item').forEach(item => {
          if (item !== faqItem) {
            item.classList.remove('active');
            const otherAnswer = item.querySelector('.faq-answer');
            otherAnswer.style.maxHeight = null;
            item.querySelector('.faq-icon svg').classList.remove('open');
          }
        });

        // Toggle current
        if (faqItem.classList.contains('active')) {
          faqItem.classList.remove('active');
          answer.style.maxHeight = null;
          icon.classList.remove('open');
        } else {
          faqItem.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + "px";
          icon.classList.add('open');
        }
      });
    });
  });